<template>
  <div class="evaluation-overview-layouts">
    <button
      v-for="layout in overviewLayouts"
      :key="layout.key"
      class="evaluation-overview-layouts__layout"
      :class="{ '-selected': overview.layout == layout.key }"
      type="button"
      :style="{
        'grid-template-columns': layout.templateColumns,
        'grid-template-rows': layout.templateRows,
        'grid-template-areas': layout.templateAreas
      }"
      @click="chooseLayout(layout.key)"
    >
      <div
        v-for="tile in layout.tiles"
        :key="tile"
        class="evaluation-overview-layouts__tile"
        :style="`grid-area: a${tile}`"
      ></div>
    </button>
  </div>
</template>

<script lang="ts">
import { useEvaluationOverviewStore } from "./evaluationOverviews.store";
import { overviewLayouts } from "./evaluationOverviews.store";
import type { OverviewLayoutKey } from "./evaluationOverviews.store";

export default {
  props: {
    overviewId: {
      type: Number,
      required: true
    }
  },
  setup() {
    return { overviewLayouts };
  },
  computed: {
    overview() {
      return useEvaluationOverviewStore().items[this.overviewId];
    }
  },
  methods: {
    chooseLayout(key: OverviewLayoutKey) {
      if (key == this.overview.layout) return;
      useEvaluationOverviewStore().update({ id: this.overviewId, layout: key });
    }
  }
};
</script>

<style lang="scss">
.evaluation-overview-layouts {
  display: flex;
  gap: 1rem;

  &__layout {
    width: 8rem;
    height: 5rem;
    flex-shrink: 0;
    display: grid;
    gap: 0.25rem;
    padding: 0.25rem;
    background-color: rgba(0, 0, 0, 0.025);
    border: 3px solid var(--color-grey-dark);
    border-radius: 0.5rem;

    &.-selected {
      border-color: var(--color-primary);
      box-shadow: 0 2px 4px var(--color-shadow-1);
    }

    &:hover {
      background-color: var(--color-background-close);
      border-color: var(--color-text);
    }
  }
  &__tile {
    background-color: var(--color-background);
    border-width: 3px;
    border-style: solid;
    border-color: inherit;
    height: 100%;
    width: 100%;
    min-height: 0;
  }
}
</style>
